module.exports = __webpack_public_path__ + "static/media/DrumKit.b454bdb2.png";